module.exports = __webpack_public_path__ + "Roboto-ThinItalic.588293290e86dad97fcf.woff";


//////////////////
// WEBPACK FOOTER
// c:/Wave/Projects/WCI/FastTrack/FastTrack/node_modules/roboto-fontface/fonts/roboto/Roboto-ThinItalic.woff
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-ThinItalic.woff
// module chunks = styles